import * as QueryKeys from "data";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Link,
  Skeleton,
} from "@mui/material";
import { getActiveOrganisation, useIdentity } from "contexts/identity-context";
import * as Routes from "routes";
import { UsageGraph } from "./usage-graph";
import { UsageTable } from "./usageTable";

// reactQuery
import { fetchSubscription, fetchUsage } from "data/queries";
import { useQuery } from "react-query";
import { resolveIdentityId } from "utils/identity";

export const Usage = () => {
  // useQuery
  const [identityState] = useIdentity();
  const isUser = !getActiveOrganisation(identityState);
  const identityId = resolveIdentityId(identityState, isUser);

  const subscriptionQuery = useQuery([QueryKeys.subscription, identityId], () => fetchSubscription(isUser, identityState));

  const dailyUsageStartTime = subscriptionQuery.isSuccess
    ? subscriptionQuery.data.activeSubscription.currentPeriodStart
    : 1;
  const dailyUsageEndTime = subscriptionQuery.isSuccess
    ? subscriptionQuery.data.activeSubscription.renewalDate
    : 1;
    
  const dailyUsageQuery = useQuery(
    [QueryKeys.dailyUsage, identityId],
    () => fetchUsage(
      isUser,
      identityState,
      dailyUsageStartTime * 1000,
      dailyUsageEndTime * 1000
    ),
    { enabled: !!subscriptionQuery.data }
  );

  const isLoading = subscriptionQuery.isLoading || dailyUsageQuery.isLoading;
  const isError = subscriptionQuery.isError || dailyUsageQuery.isError;
  const isSuccess = subscriptionQuery.isSuccess && dailyUsageQuery.isSuccess;


  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          gap: "24px",
          position: "relative",
        }}>
        {/* Div Total Credits and Overage */}
        <div style={{ display: "flex", height: "90px", gap: "20px" }}>
          <Card
            style={{
              marginBottom: "auto",
              display: "flex",
              flexDirection: "column",
              width: "20%",
            }}
          >

            {isError && (
              <>
                <CardHeader
                  style={{ minHeight: "90px" }}
                  subheader="Total Credits Consumed"
                />
              </>
            )}

            {isLoading && (
              <>
                <CardContent style={{ minHeight: "90px" }}>
                  <Box>
                    <Skeleton variant="rectangular" height="56px" />
                  </Box>
                </CardContent>
              </>
            )}

            {isSuccess && (
              <>
                <CardHeader
                  variant="primary"
                  title={dailyUsageQuery.data.totalCredits.toLocaleString(
                    "en-US",
                    { minimumFractionDigits: 1 }
                  )}
                  subheader="Total Credits Consumed"
                />
              </>
            )}

          </Card>
          <Card
            style={{
              width: "80%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "0  16px 0 0",
            }}>
            <CardHeader
              variant="primary"
              title={"Increase your Overage"}
              subheader="Increase your reserved Overage Budget, because no one likes dropping API calls."
            />
            <Button
              LinkComponent={Link}
              href={
                getActiveOrganisation(identityState)
                  ? Routes.orgOverage
                  : Routes.userOverage
              }
              variant="contained"
              color="primary"
              size="small"
              style={{ height: "36px" }}>
              EDIT OVERAGE
            </Button>
          </Card>
        </div>
        {/* Div Date Range and Graph Usage */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            gap: "24px",
            height: "500px",
            position: "relative",
          }}>
          <div>
            <UsageGraph />
          </div>
          <div>
            <UsageTable />
          </div>
        </div>
      </div>
    </>
  );
};
